module.exports = __webpack_public_path__ + "img/video1.f62a70df.jpg";